const defaultBtn = {
    type: 'action', // 'action' | 'link' | 'avatar
    action: null,
    link: null,
    label: null,
    icon: null,
    class: null,
    severity: 'secondary',
    rounded: true,
    iconPos: 'left',
    visible: false,
}
const state = {
    darkTheme: false,
    title: '',
    backButton: false,
    backButtonUrl: '/',
    profileButton: false,

    // Header buttons
    headerBtnLeftFirst: defaultBtn,
    headerBtnLeftSecond: defaultBtn,
    headerBtnRightFirst: defaultBtn,
    headerBtnRightSecond: defaultBtn,
}

const getters = {
    StateDarkTheme: (state) => state.darkTheme,
    StateHeaderTitle: (state) => state.title,
    StateHeaderBackButton: (state) => state.backButton,
    StateHeaderBackButtonUrl: (state) => state.backButtonUrl,
    StateHeaderProfile: (state) => state.profileButton,

    StateHeaderBtnLeftFirst: (state) => state.headerBtnLeftFirst,
    StateHeaderBtnLeftSecond: (state) => state.headerBtnLeftSecond,
    StateHeaderBtnRightFirst: (state) => state.headerBtnRightFirst,
    StateHeaderBtnRightSecond: (state) => state.headerBtnRightSecond,
}

const actions = {
    SetDarkTheme({ commit }, theme) {
        try {
            commit("setDarkTheme", theme)
        } catch { }

        // tg app theme
        try {          
            if(window.Telegram && window.Telegram.WebApp){
                if(theme) try { 
                    window.Telegram.WebApp.setBackgroundColor('#1c1c1c')
                    window.Telegram.WebApp.setHeaderColor('#1c1c1c') 
                } catch {}
                else      try { 
                    window.Telegram.WebApp.setBackgroundColor('#ffffff') 
                    window.Telegram.WebApp.setHeaderColor('#ffffff')
                } catch {}
            }
        } catch {}

        return true
    },
    SetHeaderTitle({ commit }, title) {
        try {
            commit("setTitle", title)
        } catch { }
        return true
    },
    SetHeaderBackButton({ commit }, backButton) {
        try {
            commit("setBackButton", backButton)
        } catch { }
        return true
    },
    SetHeaderBackButtonUrl({ commit }, backButtonUrl) {
        try {
            commit("setBackButtonUrl", backButtonUrl)
        } catch { }
        return true
    },
    SetHeaderProfileButton({ commit }, profileButton) {
        try {
            commit("setProfileButton", profileButton)
        } catch { }
        return true
    },
    UpdateHeader({ dispatch }, { title, backButton, backButtonUrl, profileButton }) {
        try {
            dispatch("SetHeaderTitle", title)
            dispatch("SetHeaderBackButton", backButton)
            dispatch("SetHeaderBackButtonUrl", backButtonUrl)
            dispatch("SetHeaderProfileButton", profileButton)
        } catch { }
        return true
    },

    SetHeaderBtnLeftFirst({ commit }, btn) {
        try {
            commit("setHeaderBtnLeftFirst", { ...defaultBtn, ...btn})
        } catch { }
        return true
    },
    SetHeaderBtnLeftSecond({ commit }, btn) {
        try {
            commit("setHeaderBtnLeftSecond", { ...defaultBtn, ...btn})
        } catch { }
        return true
    },
    SetHeaderBtnRightFirst({ commit }, btn) {
        try {
            commit("setHeaderBtnRightFirst", { ...defaultBtn, ...btn})
        } catch { }
        return true
    },
    SetHeaderBtnRightSecond({ commit }, btn) {
        try {
            commit("setHeaderBtnRightSecond", { ...defaultBtn, ...btn})
        } catch { }
        return true
    }
}

const mutations = {
    setDarkTheme(state, theme) {
        state.darkTheme = !state.darkTheme
        document.documentElement.classList.toggle('p-app-dark')
    },
    setTitle(state, title) {
        state.title = title
    },
    setBackButton(state, backButton) {
        state.backButton = (backButton) ? true : false
    },
    setBackButtonUrl(state, backButtonUrl) {
        state.backButtonUrl = backButtonUrl
    },
    setProfileButton(state, profileButton) {
        state.profileButton = (profileButton) ? true : false
    },

    setHeaderBtnLeftFirst(state, btn) {
        state.headerBtnLeftFirst = { ...defaultBtn, ...btn }
    },
    setHeaderBtnLeftSecond(state, btn) {
        state.headerBtnLeftSecond = { ...defaultBtn, ...btn }
    },
    setHeaderBtnRightFirst(state, btn) {
        state.headerBtnRightFirst = { ...defaultBtn, ...btn }
    },
    setHeaderBtnRightSecond(state, btn) {
        state.headerBtnRightSecond = { ...defaultBtn, ...btn }
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}